import React from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { trans } from '../../localization/language';

import Mobile from './Mobile';
import Password from './Password';
import Email from './Email';
import Realinfo from './Realinfo';
import { COUNTRY_NEED_REAL_INFO } from '../../constants';

class ActionPanel extends React.Component {
	render() {
		return (
			<div className="aside-panel">
				<Password />
				<Mobile />
				<Email />
				{this.props.language&&COUNTRY_NEED_REAL_INFO.indexOf(this.props.language.country)>=0? <Realinfo /> : null}
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		userInfo: state.data.userInfo,
		language: state.data.language
	}
}

export default connect(mapStateToProps)(ActionPanel);


// WEBPACK FOOTER //
// ./app/components/home/ActionPanel.js